import { render } from "./App.vue?vue&type=template&id=17ae1504"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17ae1504&lang=scss"

import exportComponent from "/builds/prohemo/education/mental-maps/metal-maps-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__